import { useEffect } from 'react';
import { errorReportingService } from '../services/errorReportingService';
import { behaviorAnalyticsService } from '../services/behaviorAnalyticsService';
import { healthDashboardService } from '../services/healthDashboardService';

export const useProactiveServices = (enabled: boolean = true) => {
  useEffect(() => {
    if (!enabled) return;

    // Error reporting başlat
    errorReportingService.setupGlobalHandlers();

    // Behavior analytics başlat
    behaviorAnalyticsService.setupAutoTracking();

    // Health monitoring başlat
    healthDashboardService.startMonitoring();

    // Cleanup
    return () => {
      errorReportingService.disable();
      behaviorAnalyticsService.disable();
      healthDashboardService.stopMonitoring();
    };
  }, [enabled]);

  return {
    trackAction: behaviorAnalyticsService.track.bind(behaviorAnalyticsService),
    trackFormSubmit: behaviorAnalyticsService.trackFormSubmit.bind(behaviorAnalyticsService),
    reportError: errorReportingService.reportError.bind(errorReportingService),
    getSystemHealth: healthDashboardService.getCurrentHealth.bind(healthDashboardService)
  };
};
